// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jOi5","right":"styles_right__1xbJi"};